/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToggleManualStepCompletionDto
 */
export interface ToggleManualStepCompletionDto {
    /**
     * 
     * @type {string}
     * @memberof ToggleManualStepCompletionDto
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof ToggleManualStepCompletionDto
     */
    stageDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof ToggleManualStepCompletionDto
     */
    stepDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof ToggleManualStepCompletionDto
     */
    profileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ToggleManualStepCompletionDto
     */
    month?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ToggleManualStepCompletionDto
     */
    completed: boolean;
}

/**
 * Check if a given object implements the ToggleManualStepCompletionDto interface.
 */
export function instanceOfToggleManualStepCompletionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "stageDefinitionId" in value;
    isInstance = isInstance && "stepDefinitionId" in value;
    isInstance = isInstance && "completed" in value;

    return isInstance;
}

export function ToggleManualStepCompletionDtoFromJSON(json: any): ToggleManualStepCompletionDto {
    return ToggleManualStepCompletionDtoFromJSONTyped(json, false);
}

export function ToggleManualStepCompletionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToggleManualStepCompletionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'stageDefinitionId': json['stageDefinitionId'],
        'stepDefinitionId': json['stepDefinitionId'],
        'profileId': !exists(json, 'profileId') ? undefined : json['profileId'],
        'month': !exists(json, 'month') ? undefined : (new Date(json['month'])),
        'completed': json['completed'],
    };
}

export function ToggleManualStepCompletionDtoToJSON(value?: ToggleManualStepCompletionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectId': value.projectId,
        'stageDefinitionId': value.stageDefinitionId,
        'stepDefinitionId': value.stepDefinitionId,
        'profileId': value.profileId,
        'month': value.month === undefined ? undefined : (value.month.toISOString()),
        'completed': value.completed,
    };
}

